export const BuddyExportHiddenFields = [
  '_id',
  '_class',
  'mentorID',
  'menteeID',
  'timeframeID',
  'username',
  'roles',
  'isOnline',
  'ios_sub',
  'emailConfirmed',
  'matches',
  'foreignLanguages',
  'nativeLanguage',
  'preferedMentorsIDs',
];
